import {
  converterParaBase,
  FRACAO_MULT,
  normalizarUnidadeQuantidade,
} from "@/lib/unidades";

export type ComposicaoLinhaCusto = {
  insumo_id: number;
  quantidade: string;
  unidade: string;
  unidade_base: string;
};

export function custoLinhaComposicao(
  valorAtualInsumo: number | null | undefined,
  unidadeBase: string,
  quantidadeStr: string,
  unidadeDisplay: string,
): number | null {
  if (valorAtualInsumo == null || !Number.isFinite(valorAtualInsumo)) return null;
  const qty = parseFloat(String(quantidadeStr).replace(",", ".")) || 0;
  if (qty <= 0) return null;
  const mult = FRACAO_MULT[unidadeDisplay.trim()] ?? 1;
  const qtyNorm = mult !== 1 ? qty * mult : qty;
  const [unNorm, qtyFinal] =
    mult !== 1 ? (["un", qtyNorm] as [string, number]) : normalizarUnidadeQuantidade(unidadeDisplay, qty);
  const qtyBase = converterParaBase(unidadeBase, unNorm, qtyFinal);
  return Math.round(valorAtualInsumo * qtyBase * 100) / 100;
}

export function calcularCustoTotalComposicao(
  itens: ComposicaoLinhaCusto[],
  insumosPorId: Map<number, { valorAtual?: number | null }>,
): number {
  let total = 0;
  for (const item of itens) {
    const ins = insumosPorId.get(item.insumo_id);
    const linha = custoLinhaComposicao(
      ins?.valorAtual,
      item.unidade_base || "un",
      item.quantidade,
      item.unidade,
    );
    if (linha != null) total += linha;
  }
  return Math.round(total * 100) / 100;
}

export function calcularCmvAtual(custoTotal: number, precoVenda: number): number {
  if (!precoVenda || precoVenda <= 0 || !custoTotal || custoTotal <= 0) return 0;
  return Math.round((custoTotal / precoVenda) * 10000) / 100;
}

export function calcularPrecoIdeal(custoTotal: number, cmvIdealPercent: number): number | null {
  if (!custoTotal || custoTotal <= 0 || !cmvIdealPercent || cmvIdealPercent <= 0) return null;
  return Math.round((custoTotal / (cmvIdealPercent / 100)) * 100) / 100;
}

/** Lucro por item = preço de venda − custo total. */
export function calcularLucroPorItem(precoVenda: number, custoTotal: number): number {
  if (!precoVenda || precoVenda <= 0) return 0;
  return Math.round((precoVenda - Math.max(0, custoTotal)) * 100) / 100;
}

/** Margem % = lucro / preço de venda * 100. */
export function calcularMargemLucroPercent(lucro: number, precoVenda: number): number {
  if (!precoVenda || precoVenda <= 0) return 0;
  return Math.round((lucro / precoVenda) * 10000) / 100;
}

export function corCmvAtual(cmvAtual: number, cmvIdeal: number): string {
  if (cmvAtual <= 0) return "text-foreground";
  if (cmvIdeal > 0 && cmvAtual <= cmvIdeal) return "text-emerald-600";
  return "text-client-primary";
}
